import { createUseStyles } from 'react-jss';

export const addCommissionPayment = createUseStyles({
  container: {},
});
